export default "__VITE_ASSET__C3aFmz67__"